export default __webpack_public_path__ + "static/media/3129.b43711fc.jpg";